export default function addDecimal(n){
    if(n % 1 === 0){
      console.log("n%1")
      return parseFloat(Math.round(n * 100) / 100).toFixed(1);
    }
    else{
      console.log("else")
      return parseFloat(n).toFixed(2);
    }
  }